export const topics = [
  {
    id: "t1",
    title: "一个人住的第三年，我把出租屋变成了最舒服的角落",
    categoryId: "life",
    authorId: "u1",
    date: "2025-10-08",
    type: "分享",
    excerpt: "从毛坯感的出租屋到现在的样子，我一共只花了不到两千块。分享几个便宜又出效果的小改动，独居也能很有归属感。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20small%20rented%20apartment%20corner%20with%20warm%20lamp%2C%20plants%20and%20soft%20textiles%2C%20cream%20and%20beige%20tones%2C%20natural%20daylight%2C%20lifestyle%20photography&width=1200&height=800&seq=banana-topic-01&orientation=landscape",
    tags: ["独居生活", "出租屋改造", "小预算"],
    views: 12840,
    replies: 96,
    content: [
      "搬进这间 38 平的出租屋时，它是那种一眼望到底的样板房：白墙、白灯、白地板，干净但也冷清。房东不允许大改动，我就告诉自己，那就从「能带走的东西」开始折腾。",
      "第一笔钱花在了灯光上。把顶上的冷白光换成暖黄的吸顶灯，再添了一盏可以在床头夹的小台灯。光一变，整个房间的氛围立刻就不一样了，这是我觉得性价比最高的一步。",
      "第二笔钱花在了地毯和窗帘。地毯选了大面积的奶油色短绒，窗帘换成亚麻质感，两样加起来不到四百块，却能把出租屋最生硬的地板和白墙都柔和下来。",
      "最后是绿植。我没有买贵的大型植物，而是选了几盆好养活的绿萝和虎皮兰，配上藤编花盆放在窗边。每天回家先看看它们有没有长新叶子，成了我的小仪式。",
      "三年住下来我发现，所谓归属感并不需要很贵的装修，而是那些「你亲手放进去」的东西。哪怕是几个人、几盆植物、几盏灯，都会让一个空间慢慢变成家的样子。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u8",
        content: "灯光那一段太真实了！我换完灯之后朋友来都说像换了个房子。",
        date: "2025-10-08",
        likes: 42,
        replies: [
          { id: "c1r1", authorId: "u1", content: "对！灯光大概是出租屋改造里最被低估的一项。", date: "2025-10-08", likes: 12 },
        ],
      },
      {
        id: "c2",
        authorId: "u3",
        content: "请问地毯选短绒会不会很难打理呀？养猫有点心动又有点怕。",
        date: "2025-10-09",
        likes: 18,
        replies: [
          { id: "c2r1", authorId: "u1", content: "有猫的话建议选可机洗的平织款，短绒沾毛确实要多吸两次。", date: "2025-10-09", likes: 9 },
        ],
      },
    ],
  },
  {
    id: "t2",
    title: "从单体到微服务，我踩过的 7 个坑都在这了",
    categoryId: "professional",
    authorId: "u2",
    date: "2025-10-06",
    type: "经验",
    excerpt: "团队从单体拆到微服务一年多，交了不少学费。这篇不吹架构，只讲我们真实遇到的坑和后来怎么解决的。",
    cover: "https://readdy.ai/api/search-image?query=abstract%20technology%20architecture%20concept%20with%20connected%20nodes%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20minimal%20clean%20background%2C%20editorial%20tech%20illustration&width=1200&height=800&seq=banana-topic-02&orientation=landscape",
    tags: ["微服务", "架构设计", "踩坑"],
    views: 20360,
    replies: 154,
    content: [
      "先给结论：微服务不是银弹。如果团队不到十个人，业务还在快速试错，老老实实写单体可能更划算。我们拆，是因为当时的单体已经没人敢改。",
      "坑一：过早拆分。我们把用户、订单、支付一次性拆成了七个服务，结果每次改一个需求都要跨三个仓库。后来做了一个季度，又把其中两个合并了回去。",
      "坑二：分布式事务。跨服务的一致性一开始想用两阶段提交，性能惨不忍睹。最后改成「本地消息表 + 最终一致」，业务能接受，也稳定。",
      "坑三：监控缺失。拆完之后线上出问题，日志散在各个服务里，排查一次要半小时。补上链路追踪之后，才发现问题定位时间直接砍到了几分钟。",
      "剩下的坑还包括配置管理、服务版本兼容、团队边界划分和数据库拆分。核心就一句话：先把可观测性和自动化做扎实，再去享受微服务带来的好处。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u4",
        content: "「先把可观测性做扎实」这句话值得贴在会议室墙上。",
        date: "2025-10-06",
        likes: 66,
        replies: [],
      },
      {
        id: "c2",
        authorId: "u6",
        content: "请问链路追踪你们最后选的是哪套方案？正在选型中。",
        date: "2025-10-07",
        likes: 21,
        replies: [
          { id: "c2r1", authorId: "u2", content: "OpenTelemetry 打底，后端接的自家存储，主要是为了省成本。", date: "2025-10-07", likes: 14 },
        ],
      },
    ],
  },
  {
    id: "t3",
    title: "在西北追了 12 天日落，这是我见过最治愈的颜色",
    categoryId: "food-travel",
    authorId: "u3",
    date: "2025-10-05",
    type: "分享",
    excerpt: "环线自驾 1800 公里，从青海湖到茶卡再到敦煌。附上详细路线、拍摄机位和住宿建议，直接照着走就行。",
    cover: "https://readdy.ai/api/search-image?query=golden%20sunset%20over%20vast%20northwest%20china%20desert%20dunes%2C%20warm%20amber%20sky%2C%20orange%20and%20cream%20tones%2C%20cinematic%20landscape%20photography&width=1200&height=800&seq=banana-topic-03&orientation=landscape",
    tags: ["西北旅行", "自驾", "日落"],
    views: 31520,
    replies: 208,
    content: [
      "这趟行程我们走了 12 天，路线大致是西宁—青海湖—茶卡—大柴旦—敦煌。最深的感受是，西北的美不在于某一个景点，而在于路上那些不期而遇的时刻。",
      "青海湖的那天下午下了小雨，我们都以为拍不到好片子了。结果傍晚云层裂开一道缝，光斜着照下来，整片湖面像被人打了一层金粉。那一刻同行的人都没说话。",
      "茶卡盐湖建议避开正午，人少、光柔。穿浅色衣服会更好看，红色虽然出片但真的烂大街了。带双可以下水的凉鞋，不然盐结晶会磨脚。",
      "敦煌除了莫高窟，我更想推荐的是傍晚的鸣沙山。爬到沙丘顶上看日落，风把所有脚印都吹平，坐在那里会觉得时间过得很慢。",
      "关于住宿：青海湖和茶卡旺季一定要提前两周订，敦煌市区选择多，价格也更稳。租车建议选 SUV，部分路段会有点颠。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u5",
        content: "已经在收藏夹躺好了，就等年假批下来！",
        date: "2025-10-05",
        likes: 58,
        replies: [],
      },
      {
        id: "c2",
        authorId: "u8",
        content: "请问整趟下来人均大概多少？想做个预算。",
        date: "2025-10-06",
        likes: 33,
        replies: [
          { id: "c2r1", authorId: "u3", content: "我们四个人分摊，人均六千出头，含油费和门票。", date: "2025-10-06", likes: 25 },
        ],
      },
    ],
  },
  {
    id: "t4",
    title: "用了三年 AI 写作后，我总结出真正有用的 5 个提示技巧",
    categoryId: "tech",
    authorId: "u4",
    date: "2025-10-04",
    type: "讨论",
    excerpt: "不是那种「套模板」的废话。这篇文章只讲我自己每天在用的、能明显提升输出质量的方法。",
    cover: "https://readdy.ai/api/search-image?query=minimal%20desk%20setup%20with%20laptop%20and%20notebook%2C%20warm%20amber%20desk%20lamp%2C%20cream%20background%2C%20clean%20aesthetic%2C%20tech%20lifestyle%20photography&width=1200&height=800&seq=banana-topic-04&orientation=landscape",
    tags: ["AI工具", "效率", "写作"],
    views: 26780,
    replies: 176,
    content: [
      "网上关于提示词的模板铺天盖地，但真正让我效率翻倍的，其实就几条朴素的原则。第一条：给背景，而不是给命令。",
      "与其说「帮我写一篇文案」，不如说清楚你是谁、写给谁看、希望达成什么。背景越具体，模型越不会跑偏，这比任何花哨的模板都有用。",
      "第二条：先要结构，再要内容。我会先让 AI 列出大纲和要点，确认方向对了之后，再逐段展开。这样改起来成本很低。",
      "第三条：让它自我批评。写完一稿后，我会追加一句「指出这段最弱的三个地方」，往往能逼出更好的版本。",
      "第四条是给例子，第五条是拆任务。总结下来，把 AI 当成一个需要充分沟通的实习生，而不是许愿池，输出质量自然就上来了。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u2",
        content: "「先要结构再要内容」确实好用，尤其是写长文档的时候。",
        date: "2025-10-04",
        likes: 47,
        replies: [],
      },
    ],
  },
  {
    id: "t5",
    title: "30 岁转行来得及吗？我用一年时间给了自己答案",
    categoryId: "career",
    authorId: "u6",
    date: "2025-10-03",
    type: "问答",
    excerpt: "被问过太多次这个问题了。这篇不灌鸡汤，只讲我当时怎么评估风险、怎么安排学习节奏、以及后来真实的结果。",
    cover: "https://readdy.ai/api/search-image?query=person%20writing%20in%20notebook%20by%20warm%20window%20light%2C%20cream%20and%20beige%20tones%2C%20calm%20reflective%20mood%2C%20editorial%20photography&width=1200&height=800&seq=banana-topic-05&orientation=landscape",
    tags: ["转行", "职场成长", "30岁"],
    views: 18960,
    replies: 231,
    content: [
      "先说我的答案：来得及，但「来得及」不等于「随便跳」。转行的关键是先想清楚，你换的是行业、岗位，还是只是这家公司。",
      "我当时做的是运营，想转产品。做的第一件事不是马上辞职，而是用业余时间接了两个小项目，验证自己是不是真的喜欢、真的能做好。",
      "验证完之后，我给自己定了六个月的安全垫：存够半年的生活费，再开始正式找机会。有了这笔钱，面试的时候心态会稳很多。",
      "学习节奏上，我每天固定投入两小时，周末集中做项目。重要的不是学得多快，而是能不能坚持半年不断线。",
      "一年后我拿到了 offer。回头看，真正的分水岭不是年龄，而是「你有没有在别人看不见的地方持续投入」。如果你也在犹豫，建议先从小事验证，而不是孤注一掷。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u1",
        content: "「先验证再跳」这点太重要了，很多人败在冲动上。",
        date: "2025-10-03",
        likes: 71,
        replies: [],
      },
      {
        id: "c2",
        authorId: "u7",
        content: "正处在犹豫期，看完真的有点被推动到了，谢谢你。",
        date: "2025-10-04",
        likes: 39,
        replies: [
          { id: "c2r1", authorId: "u6", content: "慢慢来，方向对了就不怕路远。有问题随时来社区问。", date: "2025-10-04", likes: 20 },
        ],
      },
    ],
  },
  {
    id: "t6",
    title: "花 50 块在家复刻了那家排两小时的网红甜品",
    categoryId: "food-travel",
    authorId: "u5",
    date: "2025-10-02",
    type: "分享",
    excerpt: "试了四次终于成功了。把所有失败点都写清楚，跟着做基本不会翻车，附完整配料表和小技巧。",
    cover: "https://readdy.ai/api/search-image?query=homemade%20dessert%20on%20ceramic%20plate%2C%20warm%20cream%20and%20amber%20tones%2C%20soft%20natural%20light%2C%20minimal%20clean%20background%2C%20food%20photography&width=1200&height=800&seq=banana-topic-06&orientation=landscape",
    tags: ["食谱", "甜品", "居家美食"],
    views: 14230,
    replies: 118,
    content: [
      "那家店我去排过一次，两小时，甜品本身很好吃但真的有点贵。回家之后我决定自己试试，前后失败了三次，第四次才接近那个味道。",
      "关键在蛋奶的比例。第一次我奶放多了，口感太稀；第二次又太稠。最后定下来淡奶油和牛奶接近 1:1，成品才够顺滑。",
      "糖的用量建议先少放，做好之后再根据口味补。不同品牌的甜度差别很大，照搬配方反而容易翻车。",
      "还有一个被忽略的细节是温度。所有液体最好先冷藏过再混合，室温太高容易起泡，影响最终的口感。",
      "复刻下来成本大概五十块，能做出六份。虽然少了排队打卡的仪式感，但周末在家做一份，配杯咖啡，也很幸福。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u8",
        content: "跟着做了，第一次就成功了！家里人都说好吃。",
        date: "2025-10-02",
        likes: 52,
        replies: [],
      },
    ],
  },
  {
    id: "t7",
    title: "求推荐：想入门露营，第一套装备应该怎么买？",
    categoryId: "interests",
    authorId: "u8",
    date: "2025-10-01",
    type: "问答",
    excerpt: "完全新手，预算有限。看攻略越看越乱，想请教大家哪些是必需的、哪些可以先用平价的？",
    cover: "https://readdy.ai/api/search-image?query=cozy%20camping%20scene%20with%20tent%20and%20warm%20lantern%20at%20dusk%2C%20amber%20and%20cream%20tones%2C%20soft%20natural%20light%2C%20lifestyle%20photography&width=1200&height=800&seq=banana-topic-07&orientation=landscape",
    tags: ["露营", "新手求助", "户外"],
    views: 9840,
    replies: 87,
    content: [
      "最近被朋友带去露营了一次，回来就彻底上头了。但市面上的装备从几百到几万都有，作为新手真的不知道该从哪里下手。",
      "我初步的想法是先买最基础的：帐篷、睡袋、防潮垫、折叠椅和营灯。预算大概控制在一千五以内，不知道这样合理吗？",
      "另外想问问大家，露营新手最容易忽略的东西是什么？以及有没有什么「千万别贪便宜」的装备，避免买了之后又得重买。",
      "城市周边有推荐的入门营地吗？最好是交通方便、能当天来回的那种。先谢谢各位前辈～",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u3",
        content: "别贪便宜的是睡袋和防潮垫，直接决定你睡得好不好。",
        date: "2025-10-01",
        likes: 45,
        replies: [
          { id: "c1r1", authorId: "u8", content: "记下了！看来这两样得多花点预算。", date: "2025-10-01", likes: 11 },
        ],
      },
      {
        id: "c2",
        authorId: "u4",
        content: "营灯和折叠椅可以先用平价的，帐篷建议直接一步到位买你说的预算上限。",
        date: "2025-10-02",
        likes: 28,
        replies: [],
      },
    ],
  },
  {
    id: "t8",
    title: "今年看过最难忘的一部电影，后劲太大了",
    categoryId: "books-media",
    authorId: "u7",
    date: "2025-09-29",
    type: "分享",
    excerpt: "散场之后我在路边坐了很久。这篇不剧透情节，只想聊聊它为什么让我重新思考「告别」这件事。",
    cover: "https://readdy.ai/api/search-image?query=cinema%20seats%20in%20warm%20dim%20light%2C%20amber%20and%20cream%20tones%2C%20nostalgic%20moody%20atmosphere%2C%20editorial%20photography&width=1200&height=800&seq=banana-topic-08&orientation=landscape",
    tags: ["电影", "影评", "告别"],
    views: 11620,
    replies: 94,
    content: [
      "我很少在看完一部电影之后说不出话，这次是个例外。散场之后我在影院门口的台阶上坐了很久，看人来人往，脑子里全是片尾的那几分钟。",
      "我喜欢它讲述「告别」的方式。没有煽情的台词，也没有刻意的巧合，只是把日常里那些细小到容易被忽略的瞬间一遍遍放大。",
      "最打动我的一个设定，是主角始终没有把想说的话说出口。生活里大多数告别不就是这样吗？我们总以为还有下次，结果往往就是最后一次。",
      "配乐也值得单独说。有几段几乎没什么旋律，只有环境的底噪，却比任何悲伤的旋律都更让人安静下来。",
      "如果你最近也在经历某种告别，我推荐你去看看它。它不会告诉你怎么办，但会让你觉得，有人理解那种说不清的情绪。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u1",
        content: "看完你这篇立刻去查了排片，这周就去。",
        date: "2025-09-29",
        likes: 36,
        replies: [],
      },
    ],
  },
  {
    id: "t9",
    title: "坚持早起 100 天，我的生活发生了哪些真实改变",
    categoryId: "experience",
    authorId: "u1",
    date: "2025-09-27",
    type: "分享",
    excerpt: "不贩卖自律焦虑。只想诚实聊聊早起给我的生活带来的变化，以及那些我至今也没做到的妥协。",
    cover: "https://readdy.ai/api/search-image?query=morning%20sunlight%20through%20sheer%20curtain%20with%20cup%20of%20coffee%2C%20warm%20cream%20and%20amber%20tones%2C%20calm%20minimal%20mood%2C%20lifestyle%20photography&width=1200&height=800&seq=banana-topic-09&orientation=landscape",
    tags: ["早起", "习惯养成", "自律"],
    views: 13480,
    replies: 132,
    content: [
      "一百天前我决定把闹钟从八点拨到六点半。不是被什么励志视频激励，只是单纯觉得每天上班前那一小时被浪费掉太可惜了。",
      "最明显的变化不是效率，而是心态。早上做完自己想做的事再去上班，一整天都会有一种「生活在自己手里」的踏实感。",
      "第二个变化是晚上睡得更早了。因为要早起，十一点之后自然就困了，不知不觉戒掉了刷手机到凌晨的习惯。",
      "当然也有做不到的地方。周末我基本还是睡到自然醒，节假日常常破功。我不想把自己包装成一个完美自律的人，那样的叙事对别人也没帮助。",
      "如果你也想试试，我的建议是别定太早，先从比现在早半小时开始。改变习惯最重要的是可持续，而不是一开始就用力过猛。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u6",
        content: "「别一开始就用力过猛」太对了，我去年就是定太早然后彻底放弃了。",
        date: "2025-09-27",
        likes: 63,
        replies: [],
      },
      {
        id: "c2",
        authorId: "u5",
        content: "早起之后你都做什么呀？想参考一下。",
        date: "2025-09-28",
        likes: 24,
        replies: [
          { id: "c2r1", authorId: "u1", content: "看几页书 + 简单做个早餐，不刷手机，简单但很治愈。", date: "2025-09-28", likes: 17 },
        ],
      },
    ],
  },
  {
    id: "t10",
    title: "小户型也能养好绿植，分享 6 种我养不死的神仙植物",
    categoryId: "interests",
    authorId: "u8",
    date: "2025-09-25",
    type: "分享",
    excerpt: "光照一般、经常忘记浇水也能活。按「好养程度」排序，附上各自的养护要点和避坑提醒。",
    cover: "https://readdy.ai/api/search-image?query=collection%20of%20green%20houseplants%20on%20wooden%20shelf%2C%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20minimal%20clean%20aesthetic%2C%20lifestyle%20photography&width=1200&height=800&seq=banana-topic-10&orientation=landscape",
    tags: ["绿植", "家居", "小户型"],
    views: 10720,
    replies: 78,
    content: [
      "作为一个曾经养死过七盆植物的人，我太懂那种「明明很用心还是养不活」的挫败感了。后来我换了思路，专挑皮实的品种，情况立刻好转。",
      "排在第一的一定是绿萝。它对光照几乎没有要求，忘了浇水也能扛很久，唯一的提醒是别让土长期积水。",
      "虎皮兰同样好养，而且特别适合小户型，竖直的生长方向一点都不占地方。它的致命伤是浇水太勤，我现在的原则是「宁干勿湿」。",
      "剩下几种是吊兰、龟背竹、橡皮树和多肉。吊兰适合挂起来养，龟背竹长得快、有设计感，橡皮树耐阴，多则是新手最容易误伤的一类，因为很多人把它当普通绿植一样天天浇水。",
      "最后送大家一句话：养植物其实是在学习「克制」。大多数植物不是被养死的，而是被过于殷勤地浇死的。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u1",
        content: "看完立刻给家里那盆快不行的多肉断水了哈哈。",
        date: "2025-09-25",
        likes: 41,
        replies: [],
      },
    ],
  },
  {
    id: "t11",
    title: "大家最近都在玩什么游戏？想找几个能长期一起玩的朋友",
    categoryId: "interests",
    authorId: "u4",
    date: "2025-09-23",
    type: "讨论",
    excerpt: "一个人打游戏有点没意思了，想找同好组个固定的开黑小队，不限平台，欢迎来聊。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20gaming%20setup%20with%20controller%20and%20warm%20lighting%2C%20amber%20and%20cream%20tones%2C%20clean%20minimal%20background%2C%20lifestyle%20photography&width=1200&height=800&seq=banana-topic-11&orientation=landscape",
    tags: ["游戏", "交友", "开黑"],
    views: 13690,
    replies: 189,
    content: [
      "最近换了个城市，之前一起开黑的朋友都联系少了，晚上一个人打游戏总觉得少了点什么。",
      "我主要玩策略类和合作类的，主机和 PC 都行。不追求上分，更看重大家一起讨论、一起开心的过程。",
      "如果你也缺一个固定队友，可以在评论区说说你常玩什么、什么时间段在线，我来整理一下拉个小群。",
      "也希望借这个帖子认识更多不同圈子的朋友，毕竟香蕉社区本来就是认识同好的地方嘛。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u7",
        content: "我我我！一般晚上九点后在线，偏好合作类。",
        date: "2025-09-23",
        likes: 29,
        replies: [
          { id: "c1r1", authorId: "u4", content: "收到，等攒够人了叫你！", date: "2025-09-23", likes: 10 },
        ],
      },
      {
        id: "c2",
        authorId: "u2",
        content: "工作原因时间不固定，但周末基本有空，算我一个。",
        date: "2025-09-24",
        likes: 16,
        replies: [],
      },
    ],
  },
  {
    id: "t12",
    title: "面了十家公司后，我整理出这份产品岗面试避雷清单",
    categoryId: "career",
    authorId: "u6",
    date: "2025-09-21",
    type: "经验",
    excerpt: "哪些信号说明这家公司不太靠谱、哪些问题一定要问清楚。都是真实经历，希望能帮你少走弯路。",
    cover: "https://readdy.ai/api/search-image?query=interview%20table%20with%20notebook%20and%20coffee%2C%20warm%20cream%20and%20amber%20tones%2C%20soft%20window%20light%2C%20calm%20professional%20mood%2C%20editorial%20photography&width=1200&height=800&seq=banana-topic-12&orientation=landscape",
    tags: ["面试", "产品经理", "求职"],
    views: 16480,
    replies: 143,
    content: [
      "这轮找工作我一共面了十家，有拿到 offer 的，也有中途就意识到不合适的。把经验整理出来，希望能帮你节省一些时间。",
      "第一个危险信号是面试流程混乱。约好的时间临时改、面试官换人不提前说，这类公司往往内部协作也有问题。",
      "第二个是只谈愿景不谈具体。如果一场面试下来，对方始终没讲清楚这个岗位具体做什么、汇报给谁、团队多大，要格外谨慎。",
      "一定要问清楚的问题包括：有无加班文化、试用期考核标准、团队人数和稳定性、以及最关键的——这个岗位为什么现在招人。",
      "最后想说，面试是双向的。你在评估他们，他们也在评估你，不必把自己放得太低。找到彼此合适的地方，比拿到一个将就的 offer 重要得多。",
    ],
    comments: [
      {
        id: "c1",
        authorId: "u5",
        content: "「面试是双向的」这句话今年才真正体会到。",
        date: "2025-09-21",
        likes: 55,
        replies: [],
      },
    ],
  },
];